import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDirectionChevronDown48 = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps, ref: Ref<SVGSVGElement>) => <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M2 12C12.86 13.13 23.63 28.2 24 36C24.36 28.2 35.14 13.13 46 12" stroke="currentColor" strokeWidth={1.6} /></svg>;
const ForwardRef = forwardRef(SvgDirectionChevronDown48);
export default ForwardRef;